import axiosApi from "./ajaxToAxios"

export const certificates = (data) => {
  return axiosApi.post({
    url: `/api/certificates`,
    data: JSON.stringify(data),
    contentType : "application/json",
  })
}